module.exports = __webpack_public_path__ + "static/img/market02.6f94ae9a.png";